module.exports = __webpack_public_path__ + "static/about_us-218731f2cdae49dc105d7f0bdd865679.jpg";